import "./user-team-soft-skills-complementarity.css";

// Short Report: User vs Team - Soft Skills Complementarity
// Unique classnames prefixed with tt-utsc- to avoid conflicts
const UserTeamSoftSkillsComplementarityReport = (comparisonResult) => {
  console.log("user-team data", comparisonResult);
  const sr = comparisonResult?.comparisonData
    ?.userTeamSoftSkillsComplementarityShortReport ||
    comparisonResult?.userTeamSoftSkillsComplementarityShortReport || {
      team_name: "FinOps",
      user_name: "Alice Johnson",
      missing_team_soft_skills: {
        Communication: 7,
        Creativity: 6,
        Leadership: 5,
      },
      user_soft_skills: { Communication: 8, Creativity: 4, Leadership: 6 },
      overview:
        "Alice covers 2 of 3 team gaps (~67% coverage): exceeds Communication (8/7) and Leadership (6/5); short on Creativity (4/6). She's a strong fit to stabilize stakeholder comms and take facilitation roles now; pair her with a creative partner or set a focused creativity upskilling track to close the last gap.",
    };

  const teamName = sr?.team_name ?? "Team";
  const userName = sr?.user_name ?? "User";

  const missingTeamSkills = sr?.missing_team_soft_skills || {};
  const userSkills = sr?.user_soft_skills || {};

  const missingSkillsCount = Object.keys(missingTeamSkills).length;
  const userSkillsCount = Object.keys(userSkills).length;

  const skillComparisons = Object.keys(missingTeamSkills).map((skill) => ({
    skill,
    teamNeed: missingTeamSkills[skill] || 0,
    userHas: userSkills[skill] || 0,
  }));

  // Helper to scale widths to 0–100% based on observed max (handles 0–1, 0–10, or 0–100 scales)
  const _maxObserved = Math.max(
    0,
    ...skillComparisons.flatMap((c) => [
      Number(c?.teamNeed ?? 0),
      Number(c?.userHas ?? 0),
    ])
  );
  const _scaleMax = _maxObserved <= 1 ? 1 : _maxObserved <= 10 ? 10 : 100;
  const valueToPercent = (v) =>
    Math.max(0, Math.min(100, ((Number(v) || 0) / _scaleMax) * 100));

  return (
    <div className="tt-utsc-short-report-container">
      <div className="tt-utsc-report-header">
        <h3>Soft Skills Complementarity</h3>
        <p>How well user skills fill team gaps</p>
      </div>

      {/* Metric Cards */}
      <div className="tt-utsc-comparison-summary">
        <div className="tt-utsc-summary-card">
          <div className="tt-utsc-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div className="tt-utsc-summary-content">
            <div className="tt-utsc-summary-value">
              {
                comparisonResult.comparisonData.skillGapsShortReport.teamData
                  .name
              }
            </div>
            <div className="tt-utsc-summary-label">Team name</div>
          </div>
        </div>

        <div className="tt-utsc-summary-card">
          <div className="tt-utsc-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
          <div className="tt-utsc-summary-content">
            <div className="tt-utsc-summary-value">
              {
                comparisonResult.comparisonData.skillGapsShortReport.userData
                  .name
              }
            </div>
            <div className="tt-utsc-summary-label">User name</div>
          </div>
        </div>

        <div className="tt-utsc-summary-card">
          <div className="tt-utsc-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="tt-utsc-summary-content">
            <div className="tt-utsc-summary-value">
              {
                comparisonResult.comparisonData.skillGapsShortReport.teamData
                  .skillsMissing.length
              }
            </div>
            <div className="tt-utsc-summary-label">
              Missing team soft skills
            </div>
          </div>
        </div>

        {/*<div className="tt-utsc-summary-card">
          <div className="tt-utsc-summary-icon" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 12l2 2 4-4" />
              <circle cx="12" cy="12" r="10" />
            </svg>
          </div>
          <div className="tt-utsc-summary-content">
            <div className="tt-utsc-summary-value">{userSkillsCount}</div>
            <div className="tt-utsc-summary-label">User soft skills</div>
          </div>
        </div>*/}
      </div>

      {/* Skills Comparison Pills */}
      <div className="tt-utsc-skills-comparison">
        <h3>Missing Team Skills</h3>

        <div className="tt-utsc-skills-section">
          {/*<div className="tt-utsc-skills-title">Missing team skills (need):</div>*/}
          <div className="tt-utsc-pill-list">
            {comparisonResult.comparisonData.skillGapsShortReport.teamData
              .skillsMissing.length === 0 ? (
              <span className="tt-utsc-no-missing-skills">
                No missing team skills!
              </span>
            ) : (
              comparisonResult.comparisonData.skillGapsShortReport.teamData.skillsMissing.map(
                (comp, index) => (
                  <span
                    key={`team-${index}`}
                    className="tt-utsc-pill tt-utsc-pill--team"
                  >
                    {comp}
                  </span>
                )
              )
            )}
          </div>
        </div>

        {/*<div className="tt-utsc-skills-section">
          <div className="tt-utsc-skills-title">User skills (has):</div>
          <div className="tt-utsc-pill-list">
            {skillComparisons.map((comp, index) => (
              <span
                key={`user-${index}`}
                className={`tt-utsc-pill tt-utsc-pill--user ${comp.userHas >= comp.teamNeed ? "tt-utsc-pill--meets" : "tt-utsc-pill--below"}`}
              >
                {comp.skill} - {comp.userHas}
              </span>
            ))}
          </div>
        </div>*/}
      </div>

      {/* Skills Comparison (Progress Bars) */}
      <div className="tt-utsc-skills-comparison">
        <h3>Skills Comparison</h3>

        <div className="tt-utcf-metrics-chart">
          {comparisonResult.comparisonData.skillGapsShortReport.skillComparison
            .length === 0 ? (
            <p className="tt-utcf-no-comparisons">No missing skills.</p>
          ) : (
            comparisonResult.comparisonData.skillGapsShortReport.skillComparison.map(
              (comp, index) => (
                <div key={index} className="tt-utcf-dimension-group">
                  <div
                    className="tt-utcf-dimension-title"
                    style={{ textAlign: "left" }}
                  >
                    {comp.skill}
                  </div>

                  {/* Team Need */}
                  <div className="tt-utcf-metric-bar-container">
                    <div className="tt-utcf-metric-info">
                      <span className="tt-utcf-metric-name">Team Need</span>
                    </div>
                    <div className="tt-utcf-metric-bar">
                      <div
                        className="tt-utcf-metric-fill tt-utcf-metric-fill--team"
                        style={{ width: `${valueToPercent(comp.teamNeed)}%` }}
                      ></div>
                      <span className="tt-utcf-metric-value">
                        {comp.teamNeed}
                      </span>
                    </div>
                  </div>

                  {/* User Has */}
                  <div className="tt-utcf-metric-bar-container">
                    <div className="tt-utcf-metric-info">
                      <span className="tt-utcf-metric-name">User Has</span>
                    </div>
                    <div className="tt-utcf-metric-bar">
                      <div
                        className={
                          `tt-utcf-metric-fill tt-utcf-metric-fill--user ` +
                          // reuse your existing pill success/fail colors on the fill:
                          (Number(comp.userHas) >= Number(comp.userHas)
                            ? "tt-utsc-pill--meets"
                            : "tt-utsc-pill--below")
                        }
                        style={{ width: `${valueToPercent(comp.userHas)}%` }}
                      ></div>
                      <span className="tt-utcf-metric-value">
                        {comp.userHas}
                      </span>
                    </div>
                  </div>
                </div>
              )
            )
          )}
        </div>
      </div>

      {/* Analysis Overview */}
      <div className="tt-utsc-insights-section">
        <h3>Analysis Overview</h3>
        <div className="tt-utsc-analysis-paragraph">
          <p>{comparisonResult.comparisonData.skillGapsShortReport.overview}</p>
        </div>
      </div>
    </div>
  );
};

export default UserTeamSoftSkillsComplementarityReport;
